export enum FeatureFlags {
    MEDIA_UPLOAD = 'MEDIA_UPLOAD',
    DISABLE_TRANSFORMATION = 'DISABLE_TRANSFORMATION',
    ANNOTATION_GENERATION = 'ANNOTATION_GENERATION',
    BACKGROUND_TRANSFORMATION = 'BACKGROUND_TRANSFORMATION',
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    CUSTOM_DOMAIN = 'CUSTOM_DOMAIN',
    CUSTOM_ORIGIN = 'CUSTOM_ORIGIN',
}
